/*
  Info-panel chip and panel behaviour for the image-blocks band.

  An asset, not an inline script in `_img-info`: on a merchandised product page the
  section renders its tiles from the entry list and that block never renders, so the
  markup would arrive with no behaviour behind it.
*/
(function () {
  function panelFor(trigger) {
    var id = trigger.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function close(panel, returnFocus) {
    if (!panel || panel.hidden) return;
    panel.hidden = true;

    var trigger = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }
  }

  /* One panel per band: a second open one would sit under its neighbour's tile
     and read as a rendering fault rather than two open cards. */
  function open(trigger) {
    var panel = panelFor(trigger);
    if (!panel) return;

    var section = trigger.closest('.img-blocks');
    if (section) {
      var others = section.querySelectorAll('[data-img-info-panel]');
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== panel) close(others[i], false);
      }
    }

    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    panel.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var opener = e.target.closest('[data-img-info-open]');
    if (opener) {
      var panel = panelFor(opener);
      if (panel && !panel.hidden) close(panel, true);
      else open(opener);
      return;
    }

    var closer = e.target.closest('[data-img-info-close]');
    if (closer) close(closer.closest('[data-img-info-panel]'), true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !e.target || !e.target.closest) return;
    var panel = e.target.closest('[data-img-info-panel]');
    if (panel) close(panel, true);
  });

  /* The editor re-renders the section around the panel; a stale open one would
     survive with no chip pointing at it. */
  document.addEventListener('shopify:section:load', function (e) {
    var panels = e.target.querySelectorAll('[data-img-info-panel]');
    for (var i = 0; i < panels.length; i++) close(panels[i], false);
  });
})();
